import React from 'react';
import cx from 'classnames';
import { Button, ButtonProps, CircularProgress } from '@ha/dsl';
import { makeStyles } from '@material-ui/core';
import { CircularProgressProps } from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'relative',
  },
  'kind-full-width': {
    width: '100%',
  },
  buttonProgress: {
    top: '50%',
    left: '50%',
    position: 'absolute',
    marginTop: -12,
    marginLeft: -12,
    color: theme.palette.ok.light,
  },
}));

type LoadingButtonKind = 'full-width';

interface Props {
  loading?: boolean;
  disabled?: boolean;
  buttonProps?: ButtonProps;
  circularProgressProps?: CircularProgressProps;
  kind?: LoadingButtonKind;
  testLocator?: string;
}

const LoadingButton: React.FC<Props> = ({
  loading = false,
  disabled = false,
  children,
  buttonProps = {
    variant: 'contained',
    color: 'primary',
    fullWidth: false,
  },
  circularProgressProps = { size: 24 },
  kind,
  testLocator,
}) => {
  const classes = useStyles();

  return (
    <div
      className={cx(classes.wrapper, {
        [classes[`kind-${kind}`]]: Boolean(kind),
      })}
      data-test-locator={testLocator}
    >
      <Button disabled={loading || disabled} {...buttonProps}>
        {children}
      </Button>
      {loading && (
        <CircularProgress
          className={classes.buttonProgress}
          {...circularProgressProps}
        />
      )}
    </div>
  );
};

export default LoadingButton;
